<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recsStore = getGroupStore('recsStore');
  let sectionsStore = getGroupStore('sectionsStore');
  let recRequestsStore = getGroupStore('recRequestsStore');
  let searchTermStore = getGroupStore('searchTermStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  import { initializeProfileStores } from '@stores/profile';

  initializeProfileStores();

  import { getCurrentUserStore } from '@stores/current_user';
  import ComponentEvents from '@utils/component-events';
  import Notification from '@utils/notification';
  import PreloadBox from '@components/PreloadBox.svelte';

  import MobileHeader from '@app-components/mobile/Header.svelte';
  import BottomBar from '@app-components/mobile/BottomBar.svelte';
  import AddRecOrSectionModal from '@app-components/modal/AddRecOrSectionModal.svelte';
  import SearchBar from '@app-components/SearchBar.svelte';
  import RecObject from '@app-components/RecObject.svelte';
  import MobileListView from '@app-components/group/MobileListView.svelte';
  import MobileMapView from '@app-components/group/MobileMapView.svelte';
  import AdminInfo from '../profile/components/AdminInfo.svelte';
  import ListCommentsMobile from '@app-components/comments/ListCommentsMobile.svelte';
  import GroupActionsBar from '@app-components/group/GroupActionsBar.svelte';
  import Track from '@utils/track';
  import { inview } from 'svelte-inview';

  import { browser } from '$app/environment';
  export let loadedRecObjects = true;
  export let loadedRecs = true;
  export let loadedSections = true;
  export let selectedGroupView = 'grid';
  export let loadSections;
  let commentId = null;

  let currentUser = getCurrentUserStore('default');
  let group = groupStore;
  let sections = sectionsStore;
  let recs = recsStore;
  let recObjects = recObjectsStore;
  let recRequests = recRequestsStore;
  let searchView = false;
  let quizQuestion = null;
  let quizExpanded = false;
  let quizInstance;
  let showAddComment = false;
  let showCommentsModal = false;
  const dispatch = createEventDispatcher();

  const dispatchUpdateGroupView = (newView) => {
    dispatch('update-group-view', { newView });
  };

  let endOfPageReached = function () {
    Track.groupPageEndReached({ currentUser: currentUser, group: group });
  };

  $: userCanEdit = !!group?.permissions?.edit;
  $: userCanContribute = !!group?.permissions?.contribute;
  $: isSignedInUser = !!(currentUser && currentUser.id);

  let recOrSectionModal = false;
  let headerOptions = ['profile', 'rec-request-group', 'get-started', 'login'];

  $: loaded = loadedRecs && loadedRecObjects && loadedSections;

  $: if (userCanEdit) {
    headerOptions = ['list-settings', 'list-share', 'edit-list'];
  }

  $: brokenLinksCount = group.broken_weblinks_count
    ? loadedRecObjects
      ? recObjects.filter((u) => u.weblink_broken).length
      : 0
    : 0;

  onMount(() => {
    let unsubGroup = group.subscribe((x) => (group = x));
    let unsubSections = sectionsStore.subscribe((x) => (sections = x));
    let unsubRecs = recsStore.subscribe((x) => (recs = x));
    let unsubRecObjects = recObjects.subscribe((x) => (recObjects = x));
    let unsubRecRequests = recRequestsStore.subscribe((x) => (recRequests = x));
    let unsubSearchTerm = searchTermStore.subscribe((x) => {
      if (x.term && x.term != '') {
        searchView = true;
      }
    });

    return () => {
      unsubGroup();
      unsubSections();
      unsubRecs();
      unsubRecRequests();
      unsubRecObjects();
      unsubSearchTerm();
    };
  });
</script>

<style style="text/scss" lang="scss">
  * :global(.ui-search) {
    box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.104103);
  }

  .no-search-results {
    background: #fff;
    padding: 20px;
    box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.12);
    border-radius: 15px;
    margin-top: 30px;
  }
</style>

<AddRecOrSectionModal
  bind:showModal={recOrSectionModal}
  addRecModal={quizQuestion != null}
  quizQuestion={quizQuestion}
  on:added-rec={(_e) => {
    if (quizQuestion) {
      quizInstance.saveAnswer(quizQuestion.id, true);
      if (quizExpanded) {
        Notification.send({
          text: `YOUR ${quizQuestion.q} HAS BEEN ADDED TO YOUR LIST!`,
        });
      }
      quizQuestion = null;
    }
  }}
  on:added-section={(e) => {
    if (e.detail.section) {
      ComponentEvents.trigger('mobile-set-current-section', {
        section: e.detail.section,
      });

      ComponentEvents.trigger('section-bar-show', {
        section: e.detail.section,
      });
    }
  }} />

<MobileHeader
  currentUser={currentUser}
  group={group}
  hideDotsMenu={group && group.permissions && !group.permissions.edit}
  options={headerOptions}
  showAppInvites={true}
  logoHref={isSignedInUser ? '/' : group.unauthenticated_logo_url}>
  <div slot="additional-actions" style="display: flex; flex-shrink: 0;">
    <div
      style="flex-shrink: 0;"
      on:click={() => {
        searchView = !searchView;
      }}>
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.026 16.8588C19.7597 14.1251 19.7201 9.65336 16.9376
          6.87087C14.1551 4.08839 9.68342 4.04881 6.94975 6.78248C4.21608
          9.51615 4.25565 13.9879 7.03814 16.7704C9.82062 19.5529 14.2923
          19.5924 17.026 16.8588Z"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M17.0261 16.8588L20.1325 19.9652"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</MobileHeader>
<div class:hidden={!showAddComment && !showCommentsModal}>
  <ListCommentsMobile
    customGroupStore={groupStore}
    addCommentPopEnabled={showAddComment}
    loaded={loaded}
    recs={recs}
    bind:commentId={commentId}
    bind:showModal={showCommentsModal} />
</div>
{#if browser && loaded}
  <GroupActionsBar
    bind:showCommentsModal={showCommentsModal}
    groupStore={groupStore}
    group={group}
    loaded={loaded}
    recs={recs}
    mobile={loaded}
    bind:commentId={commentId}
    addCommentPopEnabled={showAddComment}
    showFloatingLikeOrComment={true} />
{/if}
<BottomBar />

{#if group}
  {#if group.users && group.users[0] && currentUser && currentUser.user_flag}
    <AdminInfo user_id={group.users[0].id} group_id={group.id} mobile={true} />
  {/if}
  <div style="padding: 0px 30px" class="grid-page">
    <div style={searchView ? 'margin-top: 40px; display: block' : 'display: none'}>
      <SearchBar
        group={group}
        focus={searchView}
        mobile={true}
        showHide={true}
        clearText="clear"
        minimumRecs={0}
        on:hide={() => {
          searchView = false;
        }}>
        <div slot="empty" class="no-search-results" style="margin-top: 40px;">No search results found</div>

        <div slot="results" style="margin-left: 10px; margin-right: 10px;" let:searchResults>
          <div style="font-size: 13px; margin-bottom: -20px; margin-top: 10px; display: flex; justify-content: center;">
            <span style="font-weight: 500; padding-left: 10px; padding-right: 10px; padding-bottom: 10px;"
              >Results</span>
            <span style="opacity: 0.5;">{searchResults.length}</span>
          </div>
          {#each searchResults as recObject (recObject.id)}
            <RecObject id={recObject.id} showActionBar={false} mobile={true} />
          {/each}
          <div style="height: 40px" />
        </div>

        <div slot="loading" style="height: 280px; margin-top: 60px;">
          <PreloadBox />
        </div>
      </SearchBar>
    </div>

    <div style={searchView ? 'display: none' : 'display: block'}>
      {#if selectedGroupView === 'grid'}
        <MobileListView
          group={group}
          loaded={true}
          recRequests={recRequests}
          userCanEdit={userCanEdit}
          userCanContribute={userCanContribute}
          recs={recs}
          sections={sections}
          currentUser={currentUser}
          isSignedInUser={isSignedInUser}
          brokenLinksCount={brokenLinksCount}
          loadSections={() => loadSections()}
          bind:showAddComment={showAddComment}
          bind:showCommentsModal={showCommentsModal}
          on:add-button-click={(e) => {
            quizQuestion = e.detail.question;
            quizExpanded = e.detail.quizExpanded;
            quizInstance = e.detail.quizInstance;
            recOrSectionModal = true;
          }}
          on:map-view-button-click={() => dispatchUpdateGroupView('map')} />
      {:else}
        <MobileMapView
          group={group}
          loaded={true}
          isSignedInUser={isSignedInUser}
          on:leave-map-view={() => dispatchUpdateGroupView('grid')} />
      {/if}
    </div>
  </div>
{/if}
{#if loaded && group}
  <div use:inview={{}} on:enter={endOfPageReached} />
{/if}
